<div class="article middle">
    <h3 i18n>Reveal the cards</h3>
    <span i18n class="article-paragraph">Once everyone has submitted their effort estimates, the organizer
        reveals
        the cards.</span>
    <read-more class="article-paragraph" i18n>
        Subsequently, the team discusses why there were differing estimates. The goal is to agree on a common
        estimate. Afterward, the organizer can
        clear the estimates. The next task is presented – and the process starts over.
    </read-more>
</div>
